<template>
  <ButtonSquare
    v-show="
      !splitIndoorViewer &&
      !showPulseLoaderFrame1 &&
      !isFrame1CropActive &&
      !isFrame1MeasurementActive
    "
    class="tools-button"
    :imageMaxHeight="true"
    :imgSource="require('@/design-system/assets/icons/Icon-Scissors.svg')"
    activeState="inactive"
    @clicked="$emit('toolButtonClicked', 1, 'crop')"
  />
  <ButtonSquare
    v-show="
      splitIndoorViewer &&
      !showPulseLoaderFrame1 &&
      !isFrame1CropActive &&
      !isFrame1MeasurementActive
    "
    class="tools-button-split-frame1"
    :imageMaxHeight="true"
    :imgSource="require('@/design-system/assets/icons/Icon-Scissors.svg')"
    activeState="inactive"
    @clicked="$emit('toolButtonClicked', 1, 'crop')"
  />
  <ButtonSquare
    v-show="
      splitIndoorViewer &&
      !showPulseLoaderFrame2 &&
      !isFrame2CropActive &&
      !isFrame2MeasurementActive
    "
    class="tools-button-split-frame2"
    :imageMaxHeight="true"
    :imgSource="require('@/design-system/assets/icons/Icon-Scissors.svg')"
    activeState="inactive"
    @clicked="$emit('toolButtonClicked', 2, 'crop')"
  />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'

export default {
  name: 'CropButtons',
  components: {
    ButtonSquare
  },
  props: {
    splitIndoorViewer: {
      type: Boolean,
      default: false
    },
    isFrame1CropActive: {
      type: Boolean,
      default: false
    },
    isFrame1MeasurementActive: {
      type: Boolean,
      default: false
    },
    isFrame2CropActive: {
      type: Boolean,
      default: false
    },
    isFrame2MeasurementActive: {
      type: Boolean,
      default: false
    },
    showPulseLoaderFrame1: {
      type: Boolean,
      default: false
    },
    showPulseLoaderFrame2: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toolButtonClicked']
}
</script>

<style scoped lang="scss">
@use 'src/design-system/design-tokens/variables.scss';
@import 'src/styles/variables.scss';
.tools-button {
  display: flex;
  position: absolute;
  right: 14.5px;
  top: calc(28px + 10px + #{$size-button-medium} + #{variables.$layout-top-bar-height});
  z-index: variables.$z-index-indoorviewer-toolbox;
  &-split-frame1 {
    display: flex;
    position: absolute;
    left: calc((#{$width-indoorviewer} * 0.5) - 71px);
    top: calc(28px + 10px + #{$size-button-medium} + #{variables.$layout-top-bar-height});
    z-index: variables.$z-index-indoorviewer-toolbox;
  }

  &-split-frame2 {
    display: flex;
    position: absolute;
    right: 14px;
    top: calc(28px + 10px + #{$size-button-medium} + #{variables.$layout-top-bar-height});
    z-index: variables.$z-index-indoorviewer-toolbox;
  }
}
@media screen and (max-width: 1024px) {
  .tools-button {
    display: flex;
    position: absolute;
    top: calc(28px + 10px + #{$size-button-medium});
    right: 11px;
    z-index: variables.$z-index-indoorviewer-toolbox;

    &-split-frame1 {
      display: flex;
      position: absolute;
      left: calc((#{$width-indoorviewer} * 0.5) - 71px);
      top: calc(28px + 10px + #{$size-button-medium});
      z-index: variables.$z-index-indoorviewer-toolbox;
    }

    &-split-frame2 {
      display: flex;
      position: absolute;
      right: 11px;
      top: calc(28px + 10px + #{$size-button-medium});
      z-index: variables.$z-index-indoorviewer-toolbox;
    }
  }
}

@media screen and (max-width: 658px) {
  .tools-button {
    margin-right: 14px;
    &-split-frame2 {
      right: 25px;
    }
  }
}
</style>
